import {intToBase} from '../../../../helpers/base-conversions';
import {IIpSubnetConstants} from './models/ip-subnet-calculator.state';
import {SUBNET_MASKS_MAPPING} from './constants';
import {Netmask} from 'netmask';

export const getIpSubnetConstsByMaskBits = (newMaskBits: number): IIpSubnetConstants => {
  return {
    subnetMask: SUBNET_MASKS_MAPPING[newMaskBits],
    subnetBits: newMaskBits,
    maskBits: newMaskBits,
    maximumSubnets: Math.pow(2, newMaskBits),
    hostsPerSubnet: Math.pow(2, 32 - newMaskBits) - 2,
  };
};

export const getBaseInfo = (
  ipAddress: string,
  mask: number
):
  | {
      hostAddressRange: string;
      subnetId: string;
      broadCastAddress: string;
    }
  | undefined => {
  if (!isIpAddressValid(ipAddress)) {
    return;
  }
  const network = new Netmask(`${ipAddress}/${mask}`);
  return {
    broadCastAddress: network.broadcast,
    hostAddressRange: `${network.first} - ${network.last}`,
    subnetId: network.base,
  };
};

export const isIpAddressValid = (ipAddress: string) => {
  return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
    ipAddress
  );
};

export const getWildcardMask = (subnetMask: string) => {
  const octets = subnetMask.split('.');
  return octets.map((item) => 255 - Number(item)).join('.');
};

export const getHexIp = (ip: string): string => {
  const octets = ip.split('.');
  return octets.reduce<string>((acc, item, index) => {
    const hex = intToBase(item, 16);
    if (!hex) return '';

    const value = hex.length === 1 ? `0${hex}` : hex;
    if (index === 0) {
      return value;
    }
    return `${acc}.${value}`;
  }, '');
};

export const getBitmap = (maskBits: number) => {
  const chars = `${Array(maskBits + 1).join('s')}${Array(32 - maskBits + 1).join('h')}`;
  return chars.match(/.{8}/g)?.join('.');
};
